import axios from 'axios';


//Get All Feature List
export const fetchFeature = async () => {
  var response = await axios.get('/api/feature/SelectAll/');
  return response.data.data;
};

//Get Feature 
export const SelectAllFeatureList = async () => {
  var response = await axios.post('/api/Feature/SelectAllFeatureList/');
  return response.data.records;
};

//Get Feature MG
export const SelectAllFeatureListMG = async () => {
  var response = await axios.post('/api/Feature/SelectAllFeatureListMG/');
  return response.data.records;
};

//Get Feature ME
export const SelectAllFeatureListME = async () => {
  var response = await axios.post('/api/Feature/SelectAllFeatureListME/');
  return response.data.records;
};

//Delete Feature
export const deleteFeature = async (data) => {
  {
    if (data.menuType === 'MG') {
      try {
        const response = await axios.post(`/api/feature/deleteGroup`, {
          MenuGroupCode: data.menuGroupCode,
        });
        if (response && response.status === 200) {
          return response.data.status;
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      try {
        const response = await axios.post(`/api/feature/delete`, {
          FeatureID: data.featureID,
        });
        if (response && response.status === 200) {
          return response.data.status;
        }
      } catch (error) {
        console.error(error);
      }
      console.log("Delete single line")
    }
  }
};

//Delete Permission Feature
export const Delete = async (id,menuType,menuGroupCode) => {
  const data = {
    FeatureId: id,
    MenuType: menuType,
    MenuGroupCode: menuGroupCode
  }
  try {
    const response = await axios.post(`/api/Feature/Delete`, data);
    console.log('response in 67', response);
    if (response && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

//Select Feature Item By ID
export const SelectByID = async (id) => {
  let data = {
    FeatureId: parseInt(id),
  }
  try {
    const response = await axios.post('/api/Feature/SelectById/',data)
    return response.data.data;
  } catch (error) {
    console.error(error);
  }
}

//Select Feature Item By MenuCode
export const SelectBycode = async (menuCode) => {
  const data = {
    MenuCode: menuCode
  }
  try {
    const response = await axios.post('/api/Feature/SelectBycode/',data)
    return response.data.records;
  } catch (error) {
    console.error(error);
  }
}



//Create & Edit Feature
export const saveFeature = async (values) => {
  let data;
  if(values.MenuType == "MG"){
    data = {
      MenuType: values.MenuType,
      MenuCode: values.MenuCode,
      MenuGroupCode: values.MenuCode,
      ModuleCode: values.ModuleCode,
      MenuName: values.MenuName,
      PageURL: values.PageURL,
      DefaultExpanse: Boolean(parseInt(values.DefaultExpanse)),
      ExtendedPerm: values.ExtendedPerm,
      CreatedBy: values.CreatedBy,
    }
  }else if(values.MenuType == "ME"){
    data = {
      MenuType: values.MenuType,
      MenuCode: values.MenuCode,
      MenuGroupCode: values.selectedGroup.value,
      ModuleCode: values.ModuleCode,
      MenuName: values.MenuName,
      PageURL: values.PageURL,
      DefaultExpanse: Boolean(parseInt(values.DefaultExpanse)),
      ExtendedPerm: values.ExtendedPerm,
      CreatedBy: values.CreatedBy,
    }
  }
  
  var response;
  if (values.rowKey === "" || values.rowKey === null) {
    response = axios.post('/api/feature/Create', data)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error;
      });
  }
  else {
    data.FeatureID = parseInt(values.FeatureID);
    response = axios.put('/api/Feature/Update', data)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error;
      });
  }
  return response;
};


export const UpdateMenuGroup = async (value, fid) => {
  const data = {
    FeatureId: fid,
    MenuGroupCode: value.toString(),
  }
  var response = axios.put('/api/Feature/UpdateMenuGroup', data)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
  return response;
}

export const SelectByGroup = async ( menuGroupCode ) => {
  const data = {
    MenuGroupCode: menuGroupCode.toString(),
  }
  try {
    const response = await axios.post('/api/Feature/SelectByGroup/',data)
      return response.data;
  } catch (error) {
    console.error(error);
  }
}

export const SelectByGroupAll = async ( menuGroupCode ) => {
  const data = {
    MenuGroupCode: menuGroupCode.toString(),
  }
  try {
    const response = await axios.post('/api/Feature/SelectByGroupAll/',data)
      return response.data;
  } catch (error) {
    console.error(error);
  }
}

export const DeleteMultiPermission = async (data) => {
  try {
    const response = await axios.post(`/api/feature/DeleteMultiPermission`, {
      FeatureID: data,
    });
    if (response && response.status === 200) {
      return response.data.status;
    }
  } catch (error) {
    console.error(error);
  }
}